import { useMelwaysInfo } from '@seek/melways-react';

export const useLearnMoreLink = () => {
  const { country, language } = useMelwaysInfo();
  switch (country) {
    case 'au':
      return 'https://help.au.seek.com/s/article/Show-strong-interest-in-the-jobs-you-really-want';
    case 'nz':
      return 'https://help.nz.seek.com/s/article/Show-strong-interest-in-the-jobs-you-really-want';
    case 'my':
      return 'https://help.my.jobstreet.com/s/article/Show-strong-interest-in-the-jobs-you-really-want';
    case 'sg':
      return 'https://help.sg.jobstreet.com/s/article/Show-strong-interest-in-the-jobs-you-really-want';
    case 'ph':
      return 'https://help.ph.jobstreet.com/s/article/Show-strong-interest-in-the-jobs-you-really-want';
    case 'id':
      return language === 'id'
        ? 'https://help.id.jobstreet.com/id/s/article/Show-strong-interest-in-the-jobs-you-really-want?language=in'
        : 'https://help.id.jobstreet.com/id/s/article/Show-strong-interest-in-the-jobs-you-really-want?language=en_US';
    case 'hk':
      return 'https://help.hk.jobsdb.com/s/article/Show-strong-interest-in-the-jobs-you-really-want';
    case 'th':
      return language === 'th'
        ? 'https://help.th.jobsdb.com/th/s/article/Show-strong-interest-in-the-jobs-you-really-want?language=th'
        : 'https://help.th.jobsdb.com/th/s/article/Show-strong-interest-in-the-jobs-you-really-want?language=en_US';
    default:
      return 'https://help.au.seek.com/s/article/Show-strong-interest-in-the-jobs-you-really-want';
  }
};
